import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import "./Prescription.css";
import { Divider } from "antd";
import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import { Col, Row } from "react-bootstrap";
import {
  createPrescription,
  getPrescriptionCategories,
} from "../../Components/Helpers/API/PrescriptionApi/PrescriptionApi";
import { toast } from "react-toastify";
import { validatePrescription, validatePrescriptionDetails } from "../../Components/Helpers/Utilities/Validations/Prescription";
import { useNavigate } from "react-router-dom";
import CreateSelectField from "../../Components/Commons/Forms/CreateSelectField";

/**
 *  Add prescription template
 */
function CreatePrescription() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState({
    prescription_name: false,
    description: false,
  });
  const [newPrescription, setNewPrescription] = useState({
    prescription_name: "",
    description: "",
    prescription_count: 1,
    category_name: 1,
    prescription_details: [
      {
        generic: "",
        brand: "",
        quantity: "",
        preparation: "",
        form: "",
        dosage: "",
        frequency: "",
        duration: "",
        timing: "",
      },
    ],
  });

  const handleAddRow = () => {
    const newRow = {
      generic: "",
      brand: "",
      quantity: "",
      preparation: "",
      form: "",
      dosage: "",
      frequency: "",
      duration: "",
      timing: "",
    };
    setNewPrescription((prev) => ({
      ...prev,
      prescription_details: [...newPrescription.prescription_details, newRow],
    }));
  };
  const handleDeleteRow = (rowId) => {
    var _prescriptionDetail = newPrescription.prescription_details;
    _prescriptionDetail.splice(rowId, 1);
    setNewPrescription((prev) => ({
      ...prev,
      prescription_details: _prescriptionDetail,
    }));
  };

  const handleAddChange = (e, rowIndex, isSelectField) => {
    const { name, value } = e.target;

    if (isSelectField) {
      setNewPrescription((prev) => ({
        ...prev,
        category_name: { ...e.target, name: "category_name" },
      }));
    } else {
      if (rowIndex !== "") {
        var _newPrescription = { ...newPrescription };
        _newPrescription.prescription_details[rowIndex][name] = value;
        setNewPrescription((prev) => ({
          ...prev,
          _newPrescription,
        }));
      } else {
        setNewPrescription((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  async function handleSubmit() {
    setIsClicked(true);
    if (validatePrescription(newPrescription, setIsError)) {
      const res = await createPrescription(newPrescription);

      if (res.data) {
        toast.success(res.data.message);
        setTimeout(() => {
          navigate("/prescription"); // go back to manager
        }, 1000);
      } else if (res.error) {
        if (res.error.status === 400) {
          res.error.data.messages.error_messages.forEach((errMsg) => {
            toast.error(errMsg);
          });
        } else {
          toast.error(
            res.error.data.message ||
              res.error.data.messages.error_messages.message ||
              "Something went wrong."
          );
        }
      }
    }
    setIsClicked(false);
  }
  async function fetchPrescriptionCategories() {
    const res = await getPrescriptionCategories();
    if (res.data) {
      var _parsed = [];
      res.data.data.forEach((category) => {
        _parsed.push({
          name: "category_name",
          label: category.name || "-",
          value: category.id,
        });
      });
      setCategories(_parsed);
    } else if (res.error) {
      setCategories([]);
    }
  }

  useEffect(() => {
    fetchPrescriptionCategories();
  }, []);
 
  return (
    <div className="App">
      <Sidebar />
      <div className="col prescription-container p-5 pt-4">
        <LabelHeader text={"ADD PRESCRIPTION"} />
        <div className="prescription-body pt-5 ml-7">
          <div className="row mt-2">
            <div>
              <TextField
                required
                id="prescription_name"
                type={`inline`}
                formLabel={`Prescription Name`}
                size={`sm`}
                name="prescription_name"
                value={newPrescription.prescription_name}
                isError={isError.prescription_name}
                onChange={(e) => handleAddChange(e, "")}
                errorMessage="Prescription name is required."
              />
            </div>
            <div>
              <TextField
                id="description"
                type={`inline`}
                formLabel={`Description`}
                size={`sm`}
                name="description"
                value={newPrescription.description}
                onChange={(e) => handleAddChange(e, "")}
              />
            </div>
            <div>
              <CreateSelectField
                formLabel={`Category`}
                options={categories}
                value={newPrescription.category_name}
                onChange={(e) => handleAddChange({ target: e }, "", true)}
                type={"inline"}
              />
            </div>
          </div>
          <Divider />
          <div>
            <Row>
              <Col>
                <h4>Prescription Details</h4>
              </Col>
              <Col xs={2} className="patient-manager">
                <BtnAdd label={`+ Add Medicine`} onClick={handleAddRow} />
              </Col>
            </Row>

            <div className="prescription-table">
              <Table className="mt-4">
                <TableHead>
                  <TableRow>
                    <TableCell className="p-1">
                      Generic
                      {<span className="badge">*</span>}
                    </TableCell>
                    <TableCell className="p-1">
                      Brand
                    </TableCell>
                    <TableCell className="p-1">
                      Preparation
                      {<span className="badge">*</span>}
                    </TableCell>
                    <TableCell className="p-1">Quantity</TableCell>
                    <TableCell className="p-1">Form</TableCell>
                    <TableCell className="p-1">Dosage</TableCell>
                    <TableCell className="p-1">Frequency</TableCell>
                    <TableCell className="p-1">Duration</TableCell>
                    <TableCell className="p-1">Timing</TableCell>
                    {newPrescription.prescription_details.length > 1 && (
                      <TableCell className="p-1">Action</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {newPrescription.prescription_details.length === 0 ? (
                  <div>No Medicine Found!</div>
                ) : (
                  <TableBody>
                    {newPrescription.prescription_details.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className="p-1">
                          <TextField
                            label="Generic"
                            size={`xs`}
                            variant="outlined"
                            name={"generic"}
                            value={row.generic}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Brand"
                            size={`xs`}
                            variant="outlined"
                            name={"brand"}
                            value={row.brand}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Preparation"
                            size={`xs`}
                            variant="outlined"
                            name={"preparation"}
                            value={row.preparation}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Quantity"
                            size={`xs`}
                            variant="outlined"
                            name={"quantity"}
                            value={row.quantity}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Form"
                            size={`xs`}
                            variant="outlined"
                            name={"form"}
                            value={row.form}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Dosage"
                            size={`xs`}
                            variant="outlined"
                            name={"dosage"}
                            value={row.dosage}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Frequency"
                            size={`xs`}
                            variant="outlined"
                            name={"frequency"}
                            value={row.frequency}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Duration"
                            size={`xs`}
                            variant="outlined"
                            name={"duration"}
                            value={row.duration}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        <TableCell className="p-1">
                          <TextField
                            label="Timing"
                            size={`xs`}
                            variant="outlined"
                            name={"timing"}
                            value={row.timing}
                            onChange={(e) => handleAddChange(e, index)}
                          />
                        </TableCell>
                        {newPrescription.prescription_details.length > 1 && (
                          <TableCell className="p-1">
                            <IconButton
                              color="error"
                              onClick={() => handleDeleteRow(index)}
                              aria-label="delete"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </div>
            {
              validatePrescriptionDetails(newPrescription.prescription_details) && (
                <small
                  className="badge"
                  style={{
                    fontSize: 10,
                  }}
                >
                  * Required
                </small>
              )
            }
           
          </div>
        </div>
        <div className="row justify-content-end mt-5 mb-3">
          <div className="col-2 patient-manager">
            <BtnSave
              label={"Submit"}
              size={"sm"}
              onClick={handleSubmit}
              isClicked={isClicked}
              disabled={
                Object.values(newPrescription.prescription_name || "").every((value) => value === "")||
                validatePrescriptionDetails(newPrescription.prescription_details)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePrescription;
